module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_02.35508ff6.svg";